import { render, staticRenderFns } from "./TheProductList.vue?vue&type=template&id=4f593fce&"
import script from "./TheProductList.vue?vue&type=script&lang=js&"
export * from "./TheProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f593fce')) {
      api.createRecord('4f593fce', component.options)
    } else {
      api.reload('4f593fce', component.options)
    }
    module.hot.accept("./TheProductList.vue?vue&type=template&id=4f593fce&", function () {
      api.rerender('4f593fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductList.vue"
export default component.exports